import Announcement from './Announcement';
import React from 'react';
const Index = () => {
	return <Announcement />;
};
export default Index;
